import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';

function HeaderTwo() {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const username = localStorage.getItem('username');

    const handleLogout = () => {
        const accessToken = localStorage.getItem('accessToken');

        // Try to logout from the server if we have a token
        if (accessToken) {
            axios.post('https://iscreenfix.com/api/logout/', {}, {
                headers: {
                    Authorization: `Token ${accessToken}`
                }
            }).finally(() => {
                // Clear local storage and reload regardless of API response
                localStorage.removeItem('accessToken');
                localStorage.removeItem('username');
                window.location.reload();
            }).catch((error) => {
                console.error("Logout failed", error);
            });
        } else {
            // If no token, just clear local storage and reload
            localStorage.removeItem('accessToken');
            localStorage.removeItem('username');
            window.location.reload();
        }
    };

    return (
        <header className="cm-header cm-header-2">
            <div className="header px-0 px-md-5">
                <div className="container-fluid h-100">
                    <div className="row h-100 align-content-center">
                        <div className="col-md-12">
                            <nav className="navbar navbar-expand-lg navbar-light px-0">
                                <Link className="navbar-brand initiate-scripts" to={'/'}>
                                    <img src={process.env.PUBLIC_URL + '/assets/images/logo-light.png'} alt="logo" />
                                </Link>
                                <button
                                    className="navbar-toggler border-0 p-0"
                                    type="button"
                                    data-toggle="collapse"
                                    data-target="#navLinks"
                                    aria-controls="navLinks"
                                    aria-expanded="false">
                                    <span className="navbar-toggler-icon" />
                                </button>

                                <div className="collapse navbar-collapse" id="navLinks">
                                    <ul className="navbar-nav mx-auto align-items-center">
                                        <li className="nav-item dropdown active">
                                            <Link
                                                className="nav-link initiate-scripts" //dropdown-toggle
                                                to={'/'}
                                                role="button"
                                                // data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false">
                                                Home <span className="text-primary"></span>
                                            </Link>
                                            
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link initiate-scripts" to={'/services'}>Services</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link initiate-scripts" to={'/blog'}>Blog</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link initiate-scripts" to={'/team'}>Team</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link initiate-scripts" to={'/contact'}>Contact Us</Link>
                                        </li>
                                    </ul>
                                    <div className="block d-flex align-items-center mt-3 mt-lg-0">
                                        {/*
                                            <span className="icon fas fa-share-alt text-dark" role="button" />
                                            <span className="icon fas fa-search text-dark search-toggle" role="button" />
                                            <Link className="icon pr-0 pt-0 pb-0 text-dark initiate-scripts" to={'/cart'}>
                                                <span className="fas fa-shopping-bag" />
                                            </Link>
                                            */}
                                        {username ? (
                                            <div className="user-info ml-3" style={{ position: 'relative' }}>
                                                <div
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                                >
                                                    <span className="icon fas fa-user" />
                                                    <span className="ml-2">{username}</span>
                                                </div>
                                                {isDropdownOpen && (
                                                    <div style={{
                                                        position: 'absolute',
                                                        right: 0,
                                                        backgroundColor: 'white',
                                                        boxShadow: '0 2px 5px rgba(0,0,0,.2)',
                                                        borderRadius: '5px',
                                                        width: '150px',
                                                        zIndex: 1000,
                                                    }}>
                                                        <div
                                                            style={{ padding: '10px', cursor: 'pointer' }}
                                                            onClick={handleLogout}
                                                        >
                                                            Logout
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="user-info ml-3">
                                                <Link to="/login" style={{ textDecoration: 'none', color: 'inherit' }}>
                                                    <span className="icon fas fa-user" />
                                                    <span className="ml-2">Sign In</span>
                                                </Link>
                                            </div>
                                        )}
                                        <Link to={'/contact'} className="btn btn-sm btn-primary d-none d-xl-block ml-5 initiate-scripts">Get A Quote</Link>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default HeaderTwo;
